export const SITE_NAME = "Meu Barbeiro PRO";
export const SITE_DOMAIN = "https://meubarbeiropro.com";

export const ROBOTS_INDEX = "index,follow" as const;
export const ROBOTS_NOINDEX = "noindex,follow" as const;

/** Public routes eligible for sitemap and index,follow. */
export const PUBLIC_SITEMAP_PATHS = [
  "/",
  "/agenda-online-para-barbearia",
  "/home/faq",
  "/home/termos",
  "/home/privacidade",
  "/home/suporte",
  "/home/contato",
] as const;

export type PublicSitemapPath = (typeof PUBLIC_SITEMAP_PATHS)[number];

export function getSiteUrl(): string {
  const configured = process.env.NEXT_PUBLIC_APP_URL?.replace(/\/$/, "");
  if (configured && !configured.includes("localhost")) {
    return configured;
  }
  return SITE_DOMAIN;
}

export function buildCanonicalUrl(path = "/"): string {
  const base = getSiteUrl();
  if (path === "/" || path === "") {
    return base;
  }
  return `${base}${path.startsWith("/") ? path : `/${path}`}`;
}

export function buildSitemapUrl(path: PublicSitemapPath): string {
  if (path === "/") {
    return `${getSiteUrl()}/`;
  }
  return buildCanonicalUrl(path);
}
